"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _MesApi = require("@/api/MesApi");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  name: 'ContractProductionTracking',
  props: {
    contract: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      productionList: [],
      imesLogList: [],
      imesLoading: false
    };
  },
  watch: {
    contract: {
      handler: function handler() {
        this.loadProductionData();
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    loadProductionData: function loadProductionData() {
      if (this.contract && this.contract.cmsCustDesignSchemeAuditList) {
        this.productionList = this.contract.cmsCustDesignSchemeAuditList || [];
      } else {
        this.productionList = [];
      }

      this.fetchIMESLog();
    },
    fetchIMESLog: function fetchIMESLog() {
      var _this = this;

      var contractNo = this.contract && this.contract.contractNo;

      if (!contractNo) {
        this.imesLogList = [];
        return;
      }

      this.imesLoading = true;
      (0, _MesApi.syncIMESContractLog)(contractNo).then(function (response) {
        var res = response.data || response;

        if (res.code === 0 && res.data) {
          _this.imesLogList = res.data;
        } else {
          _this.imesLogList = [];
        }
      }).catch(function () {
        _this.imesLogList = [];
      }).finally(function () {
        _this.imesLoading = false;
      });
    }
  }
};
exports.default = _default2;